/*
  Util function to transform text with highlight tags like: [blueHighlight]Lorem[/blueHighlight] Ipsum
  into an object with the text and the highlights in an array by color like:
  {
    text: 'Lorem Ipsum',
    blueHighlight: ['Lorem']
  }
*/

enum ColorType {
  blueHighlight = 'blueHighlight',
  greenHighlight = 'greenHighlight',
  navyHighlight = 'navyHighlight',
  orangeHighlight = 'orangeHighlight',
  purpleHighlight = 'purpleHighlight',
  redHighlight = 'redHighlight',
}

type ParsedText = {
  text: string;
  [ColorType.blueHighlight]?: string[];
  [ColorType.greenHighlight]?: string[];
  [ColorType.navyHighlight]?: string[];
  [ColorType.orangeHighlight]?: string[];
  [ColorType.purpleHighlight]?: string[];
  [ColorType.redHighlight]?: string[];
};

const parseHighlightText = (text: string) => {
  const regex = /\[([a-z]+)Highlight\]([^[]+)\[\/([a-z]+)Highlight\]/g;

  const parsedText: ParsedText = {
    text: text.replace(regex, '$2'),
  };

  let match = regex.exec(text);

  while (match != null) {
    const [fullMatch, color, highlightText] = match;

    const colorKey = `${color}Highlight` as ColorType;

    if (parsedText[colorKey]) {
      parsedText[colorKey]?.push(highlightText);
    } else {
      parsedText[colorKey] = [highlightText];
    }

    match = regex.exec(text);
  }

  return parsedText;
};

export default parseHighlightText;
